import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e7ae732"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-2 alert alert-primary text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Cargando...", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Espere por favor...", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "list-group mt-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { align: "right" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoadingPlaces)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_ctx.places.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([{ 'active': place.id === _ctx.activePlace}, "list-group-item list-group-item-action"]),
              onClick: ($event: any) => (_ctx.onPlaceClicked(place)),
              key: place.id
            }, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(place.text), 1),
              _createElementVNode("p", null, _toDisplayString(place.place_name), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _withModifiers(($event: any) => (_ctx.getRouteDirections(place)), ["self"]),
                  class: _normalizeClass([(place.id === _ctx.activePlace ) ? 'btn-outline-light' : 'btn-outline-primary', "btn btn-outline-primary"])
                }, " Trazar ruta ", 10, _hoisted_9)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}